var render = function render(){var _vm=this,_c=_vm._self._c;return _c('delivery-detail',{staticClass:"container",attrs:{"branch":_vm.branch,"delivery":_vm.address,"lat":_vm.coordinates.lat,"long":_vm.coordinates.long,"quantity":_vm.quantity}})
}
var staticRenderFns = []

export { render, staticRenderFns }